"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePostTypeEnum = void 0;
var InvoicePostTypeEnum;
(function (InvoicePostTypeEnum) {
    InvoicePostTypeEnum["FormModule"] = "FormModule";
    InvoicePostTypeEnum["AdminLicense"] = "AdminLicense";
    InvoicePostTypeEnum["AdminLicenseAddon"] = "AdminLicenseAddon";
    InvoicePostTypeEnum["AdminLicenseAdditional"] = "AdminLicenseAdditional";
    InvoicePostTypeEnum["DashboardLicense"] = "DashboardLicense";
    InvoicePostTypeEnum["DashboardLicenseAddon"] = "DashboardLicenseAddon";
    InvoicePostTypeEnum["DashboardLicenseAdditional"] = "DashboardLicenseAdditional";
    InvoicePostTypeEnum["ReportingLicense"] = "ReportingLicense";
    InvoicePostTypeEnum["ReportingLicenseAddon"] = "ReportingLicenseAddon";
    InvoicePostTypeEnum["ReportingLicenseAdditional"] = "ReportingLicenseAdditional";
    InvoicePostTypeEnum["AllLicense"] = "AllLicense";
    InvoicePostTypeEnum["AllLicenseAddon"] = "AllLicenseAddon";
    InvoicePostTypeEnum["AllLicenseAdditional"] = "AllLicenseAdditional";
    InvoicePostTypeEnum["VoiceLicense"] = "VoiceLicense";
    InvoicePostTypeEnum["VoiceLicenseAddon"] = "VoiceLicenseAddon";
    InvoicePostTypeEnum["VoiceLicenseAdditional"] = "VoiceLicenseAdditional";
    InvoicePostTypeEnum["VoiceTariff"] = "VoiceTariff";
    InvoicePostTypeEnum["VoiceTariffAddon"] = "VoiceTariffAddon";
    InvoicePostTypeEnum["VoiceNumberMonthlyCost"] = "VoiceNumberMonthlyCost";
    InvoicePostTypeEnum["VoiceNumberMonthlyCostAddon"] = "VoiceNumberMonthlyCostAddon";
    InvoicePostTypeEnum["VoiceNumberSetupCost"] = "VoiceNumberSetupCost";
    InvoicePostTypeEnum["VoiceNumberSetupCostAddon"] = "VoiceNumberSetupCostAddon";
    InvoicePostTypeEnum["VoiceUsage"] = "VoiceUsage";
    InvoicePostTypeEnum["VoiceUsageAddon"] = "VoiceUsageAddon";
    InvoicePostTypeEnum["EmailLicense"] = "EmailLicense";
    InvoicePostTypeEnum["EmailLicenseAddon"] = "EmailLicenseAddon";
    InvoicePostTypeEnum["EmailLicenseAdditional"] = "EmailLicenseAdditional";
    InvoicePostTypeEnum["EmailAttachmentStorage"] = "EmailAttachmentStorage";
    InvoicePostTypeEnum["EmailUsage"] = "EmailUsage";
    InvoicePostTypeEnum["EmailUsageAddon"] = "EmailUsageAddon";
    InvoicePostTypeEnum["FormUsage"] = "FormUsage";
    InvoicePostTypeEnum["FormAttachmentStorage"] = "FormAttachmentStorage";
    InvoicePostTypeEnum["FormUsageAddon"] = "FormUsageAddon";
    InvoicePostTypeEnum["LicenseAddon"] = "LicenseAddon";
    InvoicePostTypeEnum["LicenseAdditional"] = "LicenseAdditional";
    InvoicePostTypeEnum["UsageAddon"] = "UsageAddon";
    InvoicePostTypeEnum["VoiceRecording"] = "VoiceRecording";
    InvoicePostTypeEnum["VoiceRecordingAddon"] = "VoiceRecordingAddon";
    InvoicePostTypeEnum["VoiceRecordingTranscript"] = "VoiceRecordingTranscript";
    InvoicePostTypeEnum["VoiceRecordingTranscriptAddon"] = "VoiceRecordingTranscriptAddon";
    InvoicePostTypeEnum["VoiceRecordingStorage"] = "VoiceRecordingStorage";
    InvoicePostTypeEnum["VoiceRecordingStorageAddon"] = "VoiceRecordingStorageAddon";
    InvoicePostTypeEnum["AiRequest"] = "AiRequest";
    InvoicePostTypeEnum["AiRequestAddon"] = "AiRequestAddon";
    InvoicePostTypeEnum["TextToVoiceUsage"] = "TextToVoiceUsage";
    InvoicePostTypeEnum["TextToVoiceUsageAddon"] = "TextToVoiceUsageAddon";
    InvoicePostTypeEnum["Addon"] = "Addon";
    InvoicePostTypeEnum["Custom"] = "Custom";
})(InvoicePostTypeEnum = exports.InvoicePostTypeEnum || (exports.InvoicePostTypeEnum = {}));
